import React from 'react';
import '../../scss/invalidateLink.scss';

const InvalidateLink = () => {
  return (
    <div className="invalidate-container">
      <div className="invalidate-box">
        <h1>Invalid Link</h1>
        <p>This link is no longer valid. Please contact your school for more information.</p>
      </div>
    </div>
  );
};

export default InvalidateLink;
